import { React, useEffect, useState, useContext } from "react";
import SearchIcon from "@mui/icons-material/Search";
import axios from "axios";
import { EventCreate, EventTable, EventOverview } from "..";
import { UserContext } from "../../App";
import { FormGroup, FormControlLabel, Switch, Button } from "@mui/material";
import "@geoapify/geocoder-autocomplete/styles/minimal.css";
import "../../styles/EventSearch.css";
import { localDate } from "../Utils/DateHelpers";
import { useCookies } from "react-cookie";
import EventAttendees from "./EventAttendees";

function EventSearch() {
  const { userType, username } = useContext(UserContext);
  const [cookies] = useCookies(["auth_token"]);

  const [events, setEvents] = useState([]);
  const [membershipLvls, setMembershipLvls] = useState([]);

  //current event fields
  const [currEvent, setCurrEvent] = useState({});
  const [currMinMembLvl, setCurrMinMembLvl] = useState("error");
  const [currMaxContacts, setCurrMaxContacts] = useState([]);
  const [registeredContacts, setRegisteredContacts] = useState({});

  const [updateTable, setUpdateTableHook] = useState(false);
  const [editedTable, setEditedTable] = useState(false);
  const [handleChange, setHandleChange] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [eventOffset, setEventOffset] = useState(0);
  const [updateOffset, setUpdateOffset] = useState(false);

  //searching terms
  const [shownEvents, setShownEvents] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showPast, setShowPast] = useState(false);

  //test fields
  const [showContacts, setShowContacts] = useState(false);

  //date for filter
  const currentDate = new Date();

  const getEvents = () => {
    const body = new FormData();
    axios.get("/events/getEvents", body).then((res) => {
      const data = res.data;
      if (data.success) {
        setEvents(data.events);
        setShownEvents(
          data.events.filter((e) => {
            const eventDate = localDate(e.endDate);
            return currentDate <= eventDate;
          })
        );
      } else {
        //add error handling
      }
    });
  };

  const getEventMaxes = () => {
    const body = new FormData();
    if (currEvent == null) {
      return;
    }
    body.append("eventId", currEvent.eventId);
    axios.post("/events/getEventMaxes", body).then((res) => {
      const data = res.data;
      if (data.success) {
        setCurrMinMembLvl(data.minMembLvl);
        setCurrMaxContacts(data.eventMaxes);
      }
    });
  };

  const getRegisteredContacts = async () => {
    //console.log(`currEvent.length = ${Object.keys(currEvent).length}`);
    if (currEvent == null || Object.keys(currEvent).length == 0) return; //Only run if there's an event selected
    try {
      //Attempt to get_signups for current event
      const response = await axios.get(`/api/events2/signups?eventId=${currEvent.eventId}`,
        cookies.auth_token ? {
          headers: { Authorization: `Bearer ${cookies.auth_token}` },
        } : {}
      );      
      setRegisteredContacts(response.data.signups);
    } catch (err) {
      console.error("Failed to get registered contacts for event", err);
    }
  };

  useEffect(() => {
    getRegisteredContacts();
    setShowContacts(false);
  }, [currEvent]);
  

  useEffect(() => {
    getEvents();
  }, []);

  useEffect(() => {
    axios.get("/events/getMembershipLevels").then((res) => {
      const data = res.data;
      if (data.success) {
        setMembershipLvls(data.membershipLevels);
      } else {
        return setMembershipLvls(["error"]);
      }
    });
  }, []);

  useEffect(() => {
    if (currEvent == null) {
      return;
    }
    getEventMaxes();
  }, [currEvent]);

  useEffect(() => {
    setUpdateOffset(!updateOffset);
    setHandleChange(false);
    setCurrentPage(0);
    getEvents();
  }, [updateTable]);

  useEffect(() => {
    var temp;
    if (!showPast) {
      temp = events.filter((e) => {
        const eventDate = localDate(e.endDate);
        return (
          currentDate <= eventDate &&
          e.event.toLowerCase().indexOf(searchTerm) != -1
        );
      });
      //reset the current event if current event is not currently in list of shown events
      setShownEvents(temp);
    } else {
      temp = events.filter(
        (e) => e.event.toLowerCase().indexOf(searchTerm) != -1
      ).reverse(); //Reverse so events go from newest to oldest
      setShownEvents(temp);
    }
    if (temp.indexOf(currEvent) == -1) {
      setCurrEvent({});
    }
  }, [searchTerm, showPast]);

  const setUpdateTable = (value) => {
    setUpdateTableHook(value);
    setSearchTerm("");
    setShowPast(false);
    setCurrEvent({});
  };
  const handlecurrEvent = (event) => {
    setCurrEvent(event);
  };

  return (
    <div className="EventSearch bg-brand-tertiary">
      <div className="EventSearch-container flex flex-col p-8 ">
        <div className="EventSearch-topContainer flex flex-wrap">
          <div className="JobSearch-searchBar flex search-button h-11 mr-4 w-60 mb-4">
            <input
              type="text"
              className="font-brand-quaternary h-full rounded-full ml-4 w-full"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <div className="my-auto mx-2">
              <SearchIcon size={16} />
            </div>
          </div>
          <FormGroup
            sx={{
              bgcolor: "white",
              borderRadius: 4,
              height: 44,
              mb: 2,
            }}
            className="search-button mr-4">
            <FormControlLabel
              control={<Switch checked={showPast} />}
              label="Show Past Events"
              onChange={(event, checked) => setShowPast(checked)}
              className="flex justify-center mx-4"
            />
          </FormGroup>
          {userType === "admin" && (
            <EventCreate
              userType={userType}
              username={username}
              updateTable={updateTable}
              setUpdateTable={setUpdateTable}
              membershipLvls={membershipLvls}
            />
          )}
        </div>
        <div className="EventSearch-bottomContainer flex h-full">
          <div className="EventSearch-leftContainer">
            <EventTable
              events={shownEvents}
              currEvent={currEvent}
              setcurrEvent={handlecurrEvent}
              username={username}
              userType={userType}
              updateTable={updateTable}
              setUpdateTable={setUpdateTable}
              updateOffset={updateOffset}
              setEventOffset={setEventOffset}
              handleChange={handleChange}
              setHandleChange={setHandleChange}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              editedTable={editedTable}
              setEditedTable={setEditedTable}
              membershipLvls={membershipLvls}
              currMinMembLvl={currMinMembLvl}
              currMaxContacts={currMaxContacts}
            />
          </div>
          <div className="EventSearch-rightContainer">
            {!(Object.keys(currEvent).length === 0 || currEvent === null) &&
              <div className="flex mb-6 border-b border-gray-300 shadow-sm">
              <button
                  onClick={() => setShowContacts(false)}
                  className={`flex-1 py-2 text-center font-bold transition ${
                    !showContacts
                      ? "border-b-4 border-brand-primary text-brand-primary"
                      : "text-gray-500"
                  }`}>
                  Event Details
                </button>
                <button
                  onClick={() => setShowContacts(true)}
                  className={`flex-1 py-2 text-center font-bold transition ${
                    showContacts
                      ? "border-b-4 border-brand-primary text-brand-primary"
                      : "text-gray-500"
                  }`}>
                  Event Attendees
                </button>
              </div>
            }
            {showContacts ?
              <EventAttendees
                membershipLvls={membershipLvls}
                registeredContacts={registeredContacts}
              />
            :
              <EventOverview
                currEvent={currEvent}
                currMinMembLvl={currMinMembLvl}
                currMaxContacts={currMaxContacts}
                membershipLvls={membershipLvls}
                registeredContacts={registeredContacts}
                localDateFunc={localDate}
              />
            }
          </div>
        </div>
      </div>
    </div>
  );
}
export default EventSearch;
